import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledContent,
  StyledContentTitle,
  StyledBold,
  StyledButtonDownload,
} from './ElementFinancial.styled'
import { getSizeFromDocument } from '../../utils/GetSizeFromDocument'
import FinancialVariantEnum from '../../enums/FinancialVariantEnum'

const ElementFinancial = ({ section, variant }) => {
  const { blocTitle, documents } = section
  if (documents === null) return null
  const filteredDocuments =
    variant === FinancialVariantEnum.investor
      ? documents.slice(0, 3)
      : documents
  let boldTitle
  let title
  if (blocTitle) {
    const formattedTabTitle = blocTitle.split(' ')
    boldTitle = formattedTabTitle[0]
    title = formattedTabTitle.splice(1).join(' ')
  }

  return (
    <StyledContent $variant={variant}>
      {blocTitle && variant !== FinancialVariantEnum.investor && (
        <StyledContentTitle>
          <StyledBold>{boldTitle}</StyledBold> {title}
        </StyledContentTitle>
      )}
      {filteredDocuments.map((document, index) => (
        <StyledButtonDownload
          key={index}
          document={document}
          description={getSizeFromDocument(document)}
          name={document.name}
        />
      ))}
    </StyledContent>
  )
}

ElementFinancial.propTypes = {
  variant: PropTypes.string,
  section: PropTypes.object.isRequired,
}

export default ElementFinancial
